(() => {
  const drawer = document.getElementById('nuvora-cart');
  if (!drawer || window.NuvoraCart) return;
  const root = () => window.Shopify?.routes?.root || '/';
  const config = () => JSON.parse(drawer.querySelector('#nc-server-data').textContent);
  let cart;
  let queue = Promise.resolve();
  let opener;
  let opening;
  let selectedUpsell;
  const error = message => {
    const el = drawer.querySelector('.nc-error');
    el.textContent = message;
    el.hidden = !message;
  };
  const cash = cents => {
    const currency = config().currency || 'AUD';
    const value = new Intl.NumberFormat('en-AU', { style: 'currency', currency }).format(cents / 100);
    return currency === 'AUD' ? value.replace(/^\$/, 'A$') : value;
  };
  async function api(path, data) {
    const response = await fetch(root() + path, {
      method: data ? 'POST' : 'GET',
      headers: data ? { 'Content-Type': 'application/json' } : {},
      body: data ? JSON.stringify(data) : undefined,
      credentials: 'same-origin'
    });
    const result = await response.json();
    if (!response.ok) throw new Error(result.description || result.message || config().messages.error);
    return result;
  }
  const read = () => api('cart.js');
  function declined(value) {
    try {
      if (value !== undefined) sessionStorage.setItem('nc-bonus-declined', value ? '1' : '0');
      return sessionStorage.getItem('nc-bonus-declined') === '1';
    } catch { return false; }
  }
  async function synchronize(current) {
    const cfg = config();
    const variants = cfg.legVariants || [];
    let lines = current.items.filter(item => item.product_id === cfg.legProductId);
    const count = lines.reduce((sum, item) => sum + item.quantity, 0);
    const tier = Math.min(3, count);
    const offer = `${tier} Legging${tier > 1 ? 's' : ''}`;
    const changes = lines.map(item => {
      const old = variants.find(v => v.id === item.variant_id);
      const next = variants.find(v => v.options[0] === old?.options[0] && v.options[1] === old?.options[1] && v.options[2] === offer);
      if (!next || next.id === item.variant_id) return null;
      return { old: item, next };
    }).filter(Boolean);
    if (changes.length) {
      await api('cart/add.js', { items: changes.map(change => ({ id: change.next.id, quantity: change.old.quantity, properties: change.old.properties || {} })) });
      const added = await read();
      const oldIds = new Set(changes.map(change => change.old.variant_id));
      const updates = Object.fromEntries(added.items.filter(item => oldIds.has(item.variant_id)).map(item => [item.key, 0]));
      current = await api('cart/update.js', { updates });
    }
    lines = current.items.filter(item => item.product_id === cfg.legProductId);
    const qualified = lines.filter(item => variants.find(v => v.id === item.variant_id)?.options[2] === '3 Leggings').reduce((sum, item) => sum + item.quantity, 0) >= 3;
    const gifts = current.items.filter(item => item.properties?._nuvora_bonus === 'true');
    const wantsGift = qualified && cfg.giftReady && cfg.giftVariant && !declined();
    if (!wantsGift && gifts.length) current = await api('cart/update.js', { updates: Object.fromEntries(gifts.map(item => [item.key, 0])) });
    if (wantsGift && !gifts.length) {
      await api('cart/add.js', { items: [{ id: cfg.giftVariant, quantity: 1, properties: { _nuvora_bonus: 'true' } }] });
      current = await read();
    } else if (wantsGift && (gifts.length > 1 || gifts[0].quantity !== 1)) {
      current = await api('cart/update.js', { updates: Object.fromEntries(gifts.map((item, i) => [item.key, i ? 0 : 1])) });
    }
    const paidGift = current.items.find(item => item.properties?._nuvora_bonus === 'true' && item.final_line_price > 0);
    if (paidGift) {
      await api('cart/change.js', { id: paidGift.key, quantity: 0 });
      throw new Error('The bonus card could not be applied for free. Please try again.');
    }
    const tankGifts = current.items.filter(item => item.product_id === 16105101132106);
    const tankCount = current.items.filter(item => item.product_id === 16104458060106).reduce((sum, item) => sum + item.quantity, 0);
    if (tankGifts.length) {
      const updates = Object.fromEntries(tankGifts.map((item, i) => [item.key, tankCount >= 3 && !i ? 1 : 0]));
      if (tankCount < 3 || tankGifts.length > 1 || tankGifts[0].quantity !== 1) current = await api('cart/update.js', { updates });
      const paidTankGift = current.items.find(item => item.product_id === 16105101132106 && item.final_line_price > 0);
      if (paidTankGift) {
        await api('cart/change.js', { id: paidTankGift.key, quantity: 0 });
        throw new Error('The free underwear could not be applied. Please try again.');
      }
    }
    return current;
  }
  function mountUpsell() {
    const product = config().upsell;
    const container = drawer.querySelector('.nc-upsell-options');
    selectedUpsell = undefined;
    if (!container) return;
    const button = drawer.querySelector('[data-nc-upsell]');
    if (!product || !Array.isArray(product.variants) || !Array.isArray(product.options)) {
      if (button) button.disabled = true;
      return;
    }
    const available = product.variants.filter(v => v.available);
    selectedUpsell = available[0];
    container.replaceChildren();
    const selects = product.options.map((option, index) => {
      const label = document.createElement('label');
      const name = typeof option === 'string' ? option : option.name;
      label.textContent = name === 'Color' || name === 'Colour' ? config().messages.colour : name === 'Size' ? config().messages.size : name;
      const select = document.createElement('select');
      select.setAttribute('aria-label', label.textContent);
      [...new Set(product.variants.map(v => v.options[index]))].forEach(value => {
        const opt = document.createElement('option');
        opt.value = value;
        opt.textContent = value === 'Gray' ? 'Grey' : value;
        select.append(opt);
      });
      select.value = selectedUpsell?.options[index] || select.options[0]?.value;
      label.append(select);
      container.append(label);
      return select;
    });
    const update = () => {
      selectedUpsell = product.variants.find(v => v.options.every((value, i) => value === selects[i].value));
      const button = drawer.querySelector('[data-nc-upsell]');
      button.disabled = !selectedUpsell?.available;
      const price = drawer.querySelector('.nc-upsell-price');
      price.replaceChildren();
      if (selectedUpsell?.compare_at_price > selectedUpsell?.price) {
        const strike = document.createElement('s');
        strike.textContent = cash(selectedUpsell.compare_at_price);
        price.append(strike);
      }
      price.append(document.createTextNode(selectedUpsell ? cash(selectedUpsell.price) : config().messages.unavailable));
      const image = drawer.querySelector('.nc-upsell-image img');
      const src = selectedUpsell?.featured_image?.src || product.featured_image;
      if (image && src) { image.src = src; image.removeAttribute('srcset'); }
    };
    selects.forEach(select => select.addEventListener('change', update));
    update();
  }
  function updateCounts(current) {
    const count = current.items.filter(item => item.properties?._nuvora_bonus !== 'true').reduce((sum, item) => sum + item.quantity, 0);
    document.querySelectorAll('cart-count,.cart-count-bubble span[aria-hidden="true"],[data-cart-count]').forEach(el => { el.textContent = count; el.classList.toggle('opacity-0', count === 0); });
    document.querySelectorAll('.velora-header a').forEach(link => {
      if (new URL(link.href, location.origin).pathname.endsWith('/cart')) link.textContent = `Cart (${count})`;
    });
  }
  async function render(current) {
    cart = current;
    const url = new URL(root(), location.origin);
    url.searchParams.set('sections', 'nuvora-cart-content');
    const response = await fetch(url, { credentials: 'same-origin' });
    const sections = await response.json();
    if (!sections['nuvora-cart-content']) throw new Error(config().messages.error);
    const document = new DOMParser().parseFromString(sections['nuvora-cart-content'], 'text/html');
    const next = document.querySelector('.nc-content');
    if (!next) throw new Error(config().messages.error);
    const scrollTop = drawer.querySelector('.nc-scroll')?.scrollTop || 0;
    drawer.querySelector('.nc-content').replaceWith(next);
    const scroll = drawer.querySelector('.nc-scroll');
    if (scroll) scroll.scrollTop = scrollTop;
    mountUpsell();
    updateCounts(current);
    window.dispatchEvent(new CustomEvent('nuvora:cart-updated', { detail: current }));
  }
  function task(operation) {
    const run = async () => {
      error('');
      drawer.setAttribute('aria-busy', 'true');
      drawer.classList.add('nc-busy');
      try { return await operation(); }
      catch (err) { error(err.message || config().messages.error); throw err; }
      finally { drawer.classList.remove('nc-busy'); drawer.removeAttribute('aria-busy'); }
    };
    const result = queue.then(run, run);
    queue = result.catch(() => {});
    return result;
  }
  function show() {
    if (!drawer.open) drawer.showModal();
    document.body.classList.add('nc-lock');
  }
  function close() {
    drawer.close();
    document.body.classList.remove('nc-lock');
    opener?.focus({ preventScroll: true });
    if (location.pathname.replace(/\/$/, '').endsWith('/cart')) location.assign(root());
  }
  function open() {
    show();
    if (opening) return opening;
    opening = task(async () => render(await synchronize(await read())))
      .finally(() => { opening = undefined; });
    return opening;
  }
  async function add(items) {
    show();
    return task(async () => {
      if (items.some(item => config().legVariants?.some(v => v.id === Number(item.id)))) declined(false);
      await api('cart/add.js', { items });
      await render(await synchronize(await read()));
    });
  }
  window.NuvoraCart = { open, add, refresh: () => task(async () => render(await synchronize(await read()))) };
  drawer.addEventListener('cancel', event => { event.preventDefault(); close(); });
  drawer.addEventListener('click', event => { if (event.target === drawer) close(); });
  document.addEventListener('click', event => {
    const target = event.target.closest('a,button');
    if (!target) return;
    const isCart = target.getAttribute('aria-controls') === 'cart-drawer' || target.hasAttribute('data-cart-toggle') || target.tagName === 'A' && new URL(target.href, location.origin).pathname.replace(/\/$/, '').endsWith('/cart');
    if (isCart && !target.closest('#nuvora-cart')) {
      event.preventDefault(); event.stopImmediatePropagation(); opener = target; open().catch(() => {});
    }
  }, true);
  drawer.addEventListener('click', event => {
    const button = event.target.closest('button');
    if (!button || button.disabled) return;
    if (button.hasAttribute('data-nc-close')) { close(); return; }
    if (button.hasAttribute('data-nc-upsell') && selectedUpsell?.available) { add([{ id: selectedUpsell.id, quantity: 1 }]).catch(() => {}); return; }
    if (button.hasAttribute('data-nc-checkout')) {
      task(async () => {
        const current = await synchronize(await read());
        if (!current.items.length) return render(current);
        const form = document.createElement('form');
        form.method = 'post';
        form.action = root() + 'cart';
        form.hidden = true;
        const input = document.createElement('input');
        input.name = 'checkout';
        input.value = '1';
        form.append(input);
        document.body.append(form);
        form.submit();
      }).catch(() => {});
      return;
    }
    const line = button.closest('.nc-line');
    if (!line) return;
    if (button.hasAttribute('data-nc-remove') || button.hasAttribute('data-nc-quantity')) {
      const quantity = button.hasAttribute('data-nc-remove') ? 0 : Math.max(0, Number(line.dataset.quantity) + Number(button.dataset.ncQuantity));
      if (line.dataset.bonus === 'true' && quantity === 0) declined(true);
      task(async () => { const current = await api('cart/change.js', { id: line.dataset.key, quantity }); await render(await synchronize(current)); }).catch(() => {});
    }
  });
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.hasAttribute('data-ionix-cart')) return;
    if (!new URL(form.action, location.origin).pathname.endsWith('/cart/add')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const data = new FormData(form);
    const id = Number(data.get('id'));
    if (!id) return;
    const properties = {};
    for (const [key, value] of data.entries()) { const match = key.match(/^properties\[(.*)\]$/); if (match) properties[match[1]] = value; }
    const item = { id, quantity: Number(data.get('quantity') || 1), properties };
    if (data.get('selling_plan')) item.selling_plan = data.get('selling_plan');
    add([item]).catch(() => {});
  }, true);
  mountUpsell();
  if (location.pathname.replace(/\/$/, '').endsWith('/cart')) open().catch(() => {});
  window.addEventListener('pageshow', event => { if (event.persisted && drawer.open) open().catch(() => {}); });
})();
